import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const CollectionOptionModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  max-height: calc(-50px + 100vh);
  height: 100%;
  padding: 0 20px 32px 20px;
  border-radius: 20px 20px 0 0;
  background-color: #fff;

  .area-click {
    width: 100%;
    height: 44px;
    font-size: 15px;
    font-weight: 500;
    color: #000;
    ${mixin.flex({ justify: 'flex-start' })};
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('0 20 32 20')};
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .area-click {
      height: ${mixin.pxToVw('44')};
      font-size: ${mixin.pxToVw('15')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    max-height: none;
    height: auto;
    padding: 32px 32px 28px 32px;
    border-radius: 0;
    width: 560px;

    .modal-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
    }

    .content {
      margin-top: 24px;
      ${mixin.flex({ direction: 'column' })};
      row-gap: 18px;

      .area-click {
        height: 50px;
        ${mixin.flex({})};
        border: 1px solid #e2e2e2;
      }
    }
  }
`;
